export default __webpack_public_path__ + "static/media/eleven.955a2aaf.jpeg";